import { useState } from "react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { apiSetSubmitStage } from "utils/API/TrxNowAPI";
import { Header, PaginationHelper, TitleBar } from "webapp/components";
import { CREMemberSearchForm } from "webapp/components/Partner/CRE/CREMemberSearchForm";
import { DRIVOMemberSearchForm } from "webapp/components/Partner/DRIVO/DRIVOMemberSearchForm";
import { AppState } from "webapp/enums/AppState";
import MemberSearchService from "webapp/services/MemberSearchService";
import { devLog } from "utils/devLog";

export default function DRIVOMemberSearch(props) {
  const { t } = useTranslation();
  const formRef = useRef();

  const [memberSearchService, setMemberSearchService] = useState(props.memberSearchService);

  const onUserBack = () => {
    if (typeof props.onUserBack === "function") {
      props.onUserBack();
    }
  };

  const onUserNext = () => {
    devLog("formRef", formRef);
    if (typeof formRef.onUserNext === "function") {
      formRef.current.submit();
    }
  };

  const onUserCancel = () => {
    if (typeof props.onUserCancel === "function") {
      props.onUserCancel();
    }
  };

  const onFormLoad = (ref) => {
    devLog("onFormLoad", formRef, ref);
    formRef.current = ref;
    devLog("onFormLoad", formRef);
  };

  const onFormSubmit = async (data) => {
    devLog("onFormSubmit.data: ", data);
    const context = props.context;
    devLog("onFormSubmit context: ", props.context);
    const naviState = context.state.navigationService.getState(AppState.MemberSearch);

    setMemberSearchService(MemberSearchService.getService());

    await memberSearchService.saveInputCache(context);
    devLog("memberSearchService", memberSearchService);
    const nextState =
      naviState && typeof naviState.nextState === "number" ? naviState.nextState : AppState.ConfirmVehicle;
    context.setState(
      {
        webAppState: nextState,
      },
      () => {
        apiSetSubmitStage(
          context.state,
          nextState,
          context.state.DisablementAddress || "DisablementAddress Not Available",
        );
        context.saveWebAppState(context);
      },
    );
  };

  const LocateUserObj = {
    img: props.logo,
    fragment: (
      <>
        <p className="mb-0">
          <strong>{t("FIMC.ContractSearch.TitleBar2")}</strong>
          <br />
        </p>
      </>
    ),
  };

  return (
    <div>
      <Header currState={props.currState} onUserBack={onUserBack} information={t("BWC.ContractSearch.TitleBar1")} />
      <TitleBar data={LocateUserObj} />
      <PaginationHelper context={props.context} />
      <DRIVOMemberSearchForm
        onFormLoad={onFormLoad}
        onFormSubmit={onFormSubmit}
        onUserCancel={onUserCancel}
        onNextClick={onUserNext}
        currState={props.currState}
        context={props.context}
        memberSearchService={memberSearchService}
      />
    </div>
  );
}
